/** Additional document. */
export class AdditionalDocument {
  constructor(data) {
    this.name = data.name;
    this.code = data.code;
  }
}
